import { RunWorkerMetricsState } from "types/generated";

import { PhaseExecutionTimeBar } from "./types";

const MINIMUM_WIDTH_PERCENT = 0.5;

export const getPhaseExecutionTimeBars = (
  states: RunWorkerMetricsState[]
): PhaseExecutionTimeBar[] => {
  const measured = states.flatMap((state) => {
    const { seconds } = state.duration;

    return seconds !== null && seconds > 0 ? [{ state, seconds }] : [];
  });
  const total = measured.reduce((sum, { seconds }) => sum + seconds, 0);

  const clamped = measured.map((measurement) => ({
    measurement,
    percent: Math.max((measurement.seconds / total) * 100, MINIMUM_WIDTH_PERCENT),
  }));
  const clampedTotal = clamped.reduce((sum, { percent }) => sum + percent, 0);

  let offsetPercent = 0;

  return clamped.map(({ measurement, percent }) => {
    const widthPercent = (percent / clampedTotal) * 100;
    const bar = { ...measurement, offsetPercent, widthPercent };
    offsetPercent += widthPercent;

    return bar;
  });
};
